"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentShoppingFinished = exports.segmentSkuViewed = void 0;
const logging_1 = require("@nerdwallet/logging");
const utils_1 = __importStar(require("./lib/utils"));
var SHIBUYA_EVENT_NAME;
(function (SHIBUYA_EVENT_NAME) {
    SHIBUYA_EVENT_NAME["SKU_VIEWED"] = "SKU Viewed";
    SHIBUYA_EVENT_NAME["SHOPPING_FINISHED"] = "Shopping Finished";
})(SHIBUYA_EVENT_NAME || (SHIBUYA_EVENT_NAME = {}));
const segmentLogger = (0, logging_1.getLogger)('SegmentSkuViewed');
const segmentTrack = (eventName, eventPayload) => {
    try {
        utils_1.default.track(eventName, Object.assign(Object.assign(Object.assign({}, (0, utils_1.convertCamelCaseToSnakeCase)(eventPayload)), (0, utils_1.getDeviceInfo)()), (0, utils_1.getDeployableInfo)()));
    }
    catch (e) {
        segmentLogger.error(e);
    }
};
const segmentSkuViewed = (skuViewedProps) => {
    segmentTrack(SHIBUYA_EVENT_NAME.SKU_VIEWED, skuViewedProps);
};
exports.segmentSkuViewed = segmentSkuViewed;
const segmentShoppingFinished = (shoppingFinishedProps) => {
    segmentTrack(SHIBUYA_EVENT_NAME.SHOPPING_FINISHED, shoppingFinishedProps);
};
exports.segmentShoppingFinished = segmentShoppingFinished;
